var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialSymbolsFamilyHomeOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 9.25L71.4167 34.6875L67.7167 39.6208L62.1667 35.4583V64.75H12.8334V35.4583L7.28337 39.6208L3.58337 34.6875L37.5 9.25ZM23.1625 37.1542C23.1625 39.8778 24.6271 42.7812 27.5563 45.8646C30.4855 48.9479 33.8 52.1597 37.5 55.5C41.2 52.1597 44.5146 48.9479 47.4438 45.8646C50.373 42.7812 51.8375 39.8778 51.8375 37.1542C51.8375 34.8931 51.0667 33.0174 49.525 31.5271C47.9834 30.0368 46.1334 29.2917 43.975 29.2917C42.6389 29.2917 41.4179 29.562 40.312 30.1026C39.2062 30.6432 38.2688 31.3493 37.5 32.2208C36.7292 31.3472 35.7662 30.6411 34.611 30.1026C33.4557 29.564 32.2604 29.2937 31.025 29.2917C28.8667 29.2917 27.0167 30.0368 25.475 31.5271C23.9334 33.0174 23.1625 34.8931 23.1625 37.1542ZM56 58.5833V30.8333L37.5 16.9583L19 30.8333V58.5833H56Z",
    fill: "#004B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsFamilyHomeOutline);
export default __webpack_public_path__ + "static/media/material-symbols_family-home-outline.b91d18aaffead9cee92fb7da0c1801f4.svg";
export { ForwardRef as ReactComponent };